import React from "react"

class ThemeProjectAdder extends React.Component {

	render() {
		return (
			<button onClick={this._handleCreateProject.bind(this)}>Créer un projet</button>
		)
	}

	_handleCreateProject() {
		this.props.onCustomAction("new_project", {theme: this.props.row.theme})
	}

}

export default ThemeProjectAdder



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/investments/theme-project-adder.js